import { Button, Flex, Icon, Icons } from "@ir/ui";
import { GetDocumentSignedURLUseCase } from "@/core/usecases/document";
import { DocumentSignedURLRepository } from "@/infrastructure/repositories/document";
import { GraphQlAdapter } from "@/infrastructure/adapters/graphQl";
import { IAttachment } from "@/core/entities/conversation";

export interface InternalConversationsFileProps {
  file: IAttachment;
  isPending: boolean;
}

const InternalConversationsFile = ({ file, isPending }: InternalConversationsFileProps) => {
  const client = GraphQlAdapter.getInstance().getClient();
  const documentSignedURLRepository = new DocumentSignedURLRepository(client);
  const getDocumentSignedURLUseCase = new GetDocumentSignedURLUseCase(documentSignedURLRepository);

  const handleDownloadFile = async (file: IAttachment) => {
    const { signedUrl } = await getDocumentSignedURLUseCase.execute(
      file.filePath,
      file.fileMimeType,
      file.fileDisplayName
    );
    if (signedUrl) {
      globalThis.open(signedUrl, "_blank");
    }
  };

  return (
    <Flex key={file.id} className="msg-file" align="center" gap={0.5}>
      {isPending ? (
        <Icon className="icon-loading-status" size="small" name={Icons.Loading} />
      ) : (
        <Icon className="msg-file-icon" name={Icons.File} />
      )}
      <Button
        htmlTitle={file.fileDisplayName}
        noStyle
        onPress={() => handleDownloadFile(file)}
        className="msg-file-name"
        style={isPending ? { cursor: "default" } : { cursor: "pointer" }}
        isDisabled={isPending}
      >
        {file.fileDisplayName}
      </Button>
    </Flex>
  );
};

export default InternalConversationsFile;
